import { Link } from "react-router-dom";
import { ManaMark } from "@/components/mh/Brand";

export const AuthShell = ({ eyebrow, title, children, footer, testId }) => (
  <div className="min-h-screen grid lg:grid-cols-[1fr_520px] bg-[#030305]" data-testid={testId}>
    <div className="hidden lg:flex flex-col justify-between p-12 border-r border-white/[0.07] relative overflow-hidden">
      <div className="absolute -bottom-40 -left-40 w-[520px] h-[520px] rounded-full bg-[#D4FF3A] opacity-[0.06] blur-3xl" />
      <Link to="/" className="flex items-center gap-3"><ManaMark size={34} /><span className="font-display text-2xl">Manahouse</span></Link>
      <div className="max-w-xl">
        <div className="font-mono text-[10px] uppercase tracking-[0.28em] text-muted-foreground">The AI workforce command center</div>
        <p className="font-display text-5xl leading-[1.05] mt-4">140 operators. Seven departments. <em className="text-muted-foreground">One quiet room where humans say the word.</em></p>
      </div>
      <div className="font-mono text-[10px] text-muted-foreground">Bring your own model · or let us run it for you</div>
    </div>
    <div className="flex flex-col justify-center px-6 sm:px-12 py-12">
      <div className="lg:hidden flex items-center gap-2.5 mb-10"><ManaMark /><span className="font-display text-xl">Manahouse</span></div>
      <div className="font-mono text-[10px] uppercase tracking-[0.28em] text-muted-foreground">{eyebrow}</div>
      <h1 className="font-display text-4xl sm:text-5xl mt-3 mb-8">{title}</h1>
      {children}
      {footer && <div className="mt-8 text-sm text-muted-foreground">{footer}</div>}
    </div>
  </div>
);

export const Field = ({ label, testId, ...props }) => (
  <label className="block">
    <span className="font-mono text-[10px] uppercase tracking-[0.2em] text-muted-foreground">{label}</span>
    <input {...props} data-testid={testId}
      className="mt-2 w-full h-11 px-4 rounded-lg bg-white/[0.03] border border-white/10 text-sm outline-none focus:border-[#D4FF3A]/60 transition-colors" />
  </label>
);

export const PrimaryBtn = ({ children, testId, ...props }) => (
  <button {...props} data-testid={testId}
    className="w-full h-11 rounded-full bg-[#D4FF3A] text-black text-sm font-semibold hover:bg-[#e2ff73] active:scale-[0.99] transition-[background-color,transform] disabled:opacity-50">
    {children}
  </button>
);

export const ErrorNote = ({ children }) => children ? <p className="text-sm text-[#FF3B5C]" data-testid="auth-error">{children}</p> : null;
